'use strict';
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/web.clear-immediate');
require('../modules/web.set-immediate');



// WEBPACK FOOTER //
// ./~/core-js/modules/web.immediate.js